<div class="container-fluid loader-container">
    <header class="d-flex space-between page-header">
        <h2>
            Niveau's
        </h2>
        <div class="actions">
            <button (click)="openModal({})" class="btn btn-primary">
                Toevoegen
            </button>
        </div>
    </header>

    <app-table-guru [apiEndpoint]="'/office/study-levels'" [columnMapping]="[
            { key: 'study.name', label: 'Studie' },
            { key: 'name', label: 'Naam' },
            { key: 'study_level_prefix', label: 'Prefix' },
          ]" [itemsPerPage]="10" [openModalComponent]="editFormReference" [reload]="reloadItems">
    </app-table-guru>
</div>